import _classCallCheck from "/opt/app/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/app/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/app/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/opt/app/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import React from 'react';
import { Form, OverlayTrigger, Tooltip } from 'react-bootstrap';

var FieldLabel = function () {
  var FieldLabel = /*#__PURE__*/function (_React$Component) {
    _inherits(FieldLabel, _React$Component);

    var _super = _createSuper(FieldLabel);

    function FieldLabel() {
      _classCallCheck(this, FieldLabel);

      return _super.apply(this, arguments);
    }

    _createClass(FieldLabel, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            label = _this$props.label,
            labelVisible = _this$props.labelVisible,
            isRequired = _this$props.isRequired;

        if (!labelVisible) {
          return false;
        }

        var tooltip = React.createElement(OverlayTrigger, {
          placement: 'top',
          overlay: React.createElement(Tooltip, {
            id: "".concat(label, "_required")
          }, 'Обязательное поле')
        }, React.createElement("i", {
          className: 'ion ion-ios-alert ml-1'
        }));
        return React.createElement(Form.Label, null, label, isRequired && tooltip);
      }
    }]);

    return FieldLabel;
  }(React.Component);

  FieldLabel.defaultProps = {
    isRequired: false,
    labelVisible: true
  };
  return FieldLabel;
}();

export { FieldLabel };